module.exports = "* {\r\n    font-family: Roboto;\r\n}\r\n\r\n#chart {\r\n    size: 40%;\r\n}\r\n\r\n.w-100{\r\n    width: 50% !important;\r\n}\r\n\r\n.h-300p{\r\n    height: 100px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/compare-members/compare-members.component.css
// module id = ./src/app/compare-members/compare-members.component.css
// module chunks = main